import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  useTheme,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const ActivitiesPopup = ({ open, onClose, activity }) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="800px" // Largura máxima reduzida
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '12px',
          boxShadow: theme.shadows[10],
          maxWidth: '800px', // Garante que não ultrapasse em telas grandes
          [theme.breakpoints.down('sm')]: { // Responsividade para mobile
            width: '95%',
            margin: '8px'
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          padding: '16px 24px',
          borderBottom: '2px solid #f0f0f0',
          position: 'relative',
          textAlign: 'center',
        }}
      >
        <Typography
          variant="h5"
          component="div"
          sx={{
            fontWeight: 600,
            color: '#7E6BA9',
            paddingRight: '40px',
            fontSize: { xs: '1.25rem', sm: '1.5rem' }, // Título responsivo
          }}
        >
          {activity.title}
        </Typography>
        
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: '50%',
            transform: 'translateY(-50%)',
            color: theme.palette.grey[600],
            '&:hover': {
              color: theme.palette.error.main,
            },
          }}
        >
          <CloseIcon fontSize="medium" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: '20px' }}>
        <Typography
          variant="body1"
          paragraph
          sx={{
            lineHeight: 1.6,
            textAlign: 'justify',
            marginBottom: '20px',
            color: '#444',
            fontSize: { xs: '0.875rem', sm: '1rem' }, // Texto responsivo
          }}
        >
          {activity.content}
        </Typography>

        {activity.images && activity.images.length > 0 && (
          <Box sx={{ 
            maxWidth: '90%', // Controla a largura do carrossel
            margin: '0 auto', // Centraliza
            padding: '0 10px',
          }}>
            <Swiper
              modules={[Navigation, Pagination]}
              navigation
              pagination={{ clickable: true }}
              spaceBetween={10}
              slidesPerView={1}
              style={{
                borderRadius: '4px',
              }}
            >
              {activity.images.map((img, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={img}
                    alt={`img-${index}`}
                    style={{
                      width: '100%',
                      maxHeight: '300px', // Altura reduzida
                      objectFit: 'contain',
                      backgroundColor: '#f8f8f8',
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ActivitiesPopup;